





















































import { Component, Mixins } from 'vue-property-decorator'
import LocaleSelector from 'vuecomponents/locale_selector.vue'
import { namespace } from 'vuex-class'

const browser = namespace('browser')

@Component({
  components: { LocaleSelector },
})
export default class LandsideFooter extends Mixins() {
  @browser.State windowWidth
  @browser.Getter isSmallerThanTabletPortrait
  @browser.Getter isBiggerThanTabletLandscape
}
